/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Fragment, useState } from 'react';
import { StyleSheet, View, ScrollView, TouchableOpacity } from 'react-native';
import { useQuery } from '@tanstack/react-query';

import LoadingIndicator from '../uiold/LoadingIndicator';
import { DataTable, Page, CodeView, Button, TextInput, Icon } from '../uiold';
import { showError, showSuccess } from '../App/AppAlert';
import { useFetchJson } from '../../support/useFetch';
import { postJSON } from '../../support/Fetch';
import formatDate from '../../core/support/formatDate';

import { Integration } from '../../types/shared/Integration';

function IntegrationSettings() {
  let fetchJson = useFetchJson();
  let { data: integrationsData, refetch } = useQuery(['integrations'], () => {
    const url = '/api/integrations';
    return fetchJson<{ integrations: Array<Integration> }>(url);
  });

  if (integrationsData == null) {
    return <Page isLoading />;
  }

  let { integrations } = integrationsData;

  return (
    <Page>
      <Page.Header title="3rd Party Integrations" />
      <IntegrationListHeader />
      <ScrollView>
        {integrations.map((integration: any) => (
          <IntegrationListItem
            key={integration.id}
            {...integration}
            refetchIntegrations={refetch}
          />
        ))}
        <CreateNewIntegration refetchIntegrations={refetch} />
      </ScrollView>
    </Page>
  );
}

type ItemProps = Integration & {
  refetchIntegrations: () => void;
};

function IntegrationListItem(props: ItemProps) {
  let { name, id, createdAt } = props;
  const [isHovering, setIsHovering] = useState(false);
  let [isDeleting, setDeleting] = useState(false);
  return (
    <DataTable.Row>
      <DataTable.Cell>{name}</DataTable.Cell>
      <DataTable.Cell
        onMouseEnter={() => {
          setIsHovering(true);
        }}
        onMouseLeave={() => setIsHovering(false)}
      >
        {isHovering ? <CodeView value={id} style={styles.key} /> : id}
      </DataTable.Cell>
      <DataTable.Cell>{createdAt ? formatDate(createdAt) : ''}</DataTable.Cell>
      <View style={styles.actionColumn}>
        <TouchableOpacity
          disabled={isDeleting}
          activeOpacity={0.6}
          onPress={() => {
            setDeleting(true);
            postJSON(`/api/integrations/${id}/revoke`, { name }, (e) => {
              setDeleting(false);
              if (e == null) {
                showSuccess('Deleted Successfully.');
                props.refetchIntegrations();
                return;
              }
              showError(`Error: ${e.message}`);
            });
          }}
        >
          <Icon name="remove" size="M" />
        </TouchableOpacity>
      </View>
    </DataTable.Row>
  );
}

function IntegrationListHeader() {
  return (
    <View style={styles.header}>
      <DataTable.HeaderCell>NAME</DataTable.HeaderCell>
      <DataTable.HeaderCell>KEY</DataTable.HeaderCell>
      <DataTable.HeaderCell>CREATED AT</DataTable.HeaderCell>
      <DataTable.HeaderCell style={styles.actionColumn} />
    </View>
  );
}

type CreateIntegrationProps = {
  refetchIntegrations: () => void;
};

function CreateNewIntegration(props: CreateIntegrationProps) {
  let [isEditing, setEditing] = useState(false);
  let [isSaving, setSaving] = useState(false);
  let [name, setName] = useState('');

  if (isSaving) {
    return <LoadingIndicator />;
  }

  return isEditing ? (
    <Fragment>
      <DataTable.Row>
        <TextInput
          placeholder="Enter key name"
          value={name}
          onChangeText={setName}
        />
      </DataTable.Row>
      <View style={styles.row}>
        <Button
          title="CANCEL"
          onPress={() => {
            setEditing(false);
            setName('');
          }}
          style={styles.button}
        />
        <Button
          isPrimary
          isDisabled={name === ''}
          title="SAVE"
          onPress={() => {
            setSaving(true);
            postJSON('/api/integrations', { name }, (e) => {
              setSaving(false);
              if (e == null) {
                showSuccess('Created Successfully.');
                setEditing(false);
                setName('');
                props.refetchIntegrations();
                return;
              }
              showError(`Error: ${e.message}`);
            });
          }}
          style={[styles.button, styles.save]}
        />
      </View>
    </Fragment>
  ) : (
    <Button
      isPrimary
      title="CREATE"
      onPress={() => setEditing(true)}
      style={styles.button}
    />
  );
}

let styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    paddingHorizontal: 20,
    paddingBottom: 8,
  },
  key: {
    maxWidth: 300,
  },
  row: {
    flexDirection: 'row',
  },
  button: {
    marginHorizontal: 0,
    alignSelf: 'flex-start',
  },
  save: {
    marginLeft: 8,
  },
  actionColumn: {
    alignItems: 'flex-end',
    justifyContent: 'center',
    maxWidth: 50,
    flex: 1,
  },
});

export default IntegrationSettings;
